export const filters = {
  EXPERIENCES: 'Experiences',
  DAY: 'Day',
  MORE: 'More'
}